//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
    data() {
            return {
                info: ''
            }
        },
        methods: {
            setImg(imgUrl,songsPlay) {
                this.$store.dispatch('setImg', [imgUrl,true]);
                this.$store.dispatch('setSongs',songsPlay);
            }
        },
        mounted() {
            axios.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com/plist/index&json=true')
                .then((response) => {
                    this.info = response.data.plist.list.info.map(function(item) {
                        item.imgurl = item.imgurl.replace('{size}', '400')
                        return item
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }
}



// WEBPACK FOOTER //
// ./src/components/xsonglist/xsonglist.vue